module.exports = __webpack_public_path__ + "assets/img/banner-clo.01ba0e82.webp";